import { root } from './request';

export const request = {
  ...root,
};
